import React, { useEffect, useState } from "react";
import { useGetSpecificFormQuery } from "../../../../Redux/service/Forms/Form";
import AntCheckBox from "../../../FormBuilderInputs/CheckBox";
import AntDatePicker from "../../../FormBuilderInputs/DatePicker";
import DropdownInput from "../../../FormBuilderInputs/DropdownInput";
import NormalInput from "../../../FormBuilderInputs/NormalInput";
import ContainerPreview from "../../../FormBuilderInputs/ContainerPreview";
import RadioGroup from "../../../FormBuilderInputs/RadioGroup";
import AntTextArea from "../../../FormBuilderInputs/TextArea";
import Toggle from "../../../FormBuilderInputs/Toggle";
import AntUpload from "../../../FormBuilderInputs/Upload";
import AntButton from "../../../FormBuilderInputs/Button";
import AntHeader from "../../../FormBuilderInputs/Header";
import Image from "../../../FormBuilderInputs/Image";
import Label from "../../../FormBuilderInputs/Label";
import Link from "../../../FormBuilderInputs/Link";
import ProgressCircle from "../../../FormBuilderInputs/ProgressCircle";
import ProgressLine from "../../../FormBuilderInputs/ProgressLine";
import UISignature from "../../../FormBuilderInputs/Signature";
import SnippetCamera from "../../../FormBuilderInputs/Camera";
import trans from "../../../../utils";

export default function IRFormSubmit({
  addData,
  submitData,
  setSubmitData,
  setConfirmationData,
  isEditing = false,
  editValues = null,
}) {
  const { data: formFields, isLoading } = useGetSpecificFormQuery(
    addData?.values?.form_id,
    { skip: !addData?.values?.form_id },
  );

  useEffect(() => {
    if (formFields) {
      setConfirmationData(formFields?.data?.formSchema?.fields);
    }
  }, [formFields]);
  const getInputType = (item) => {
    switch (item?.name) {
      case "Checkbox":
        return (
          <AntCheckBox
            item={item}
            submitData={submitData}
            setSubmitData={setSubmitData}
            addData={addData}
          />
        );
      case "DatePicker":
        return (
          <AntDatePicker
            item={item}
            submitData={submitData}
            setSubmitData={setSubmitData}
            addData={addData}
          />
        );
      case "Dropdown":
        return (
          <DropdownInput
            item={item}
            submitData={submitData}
            setSubmitData={setSubmitData}
            addData={addData}
          />
        );

      case "Input":
        return (
          <NormalInput
            item={item}
            addData={addData}
            submitData={submitData}
            setSubmitData={setSubmitData}
          />
        );
      case "Container":
        return (
          <ContainerPreview
            getInputType={getInputType}
            ukey={item?.id}
            item={item?.container}
            css={item?.css}
          />
        );
      case "Radio_group":
        return (
          <RadioGroup
            item={item}
            addData={addData}
            submitData={submitData}
            setSubmitData={setSubmitData}
          />
        );

      case "Text_area":
        return (
          <AntTextArea
            item={item}
            addData={addData}
            submitData={submitData}
            setSubmitData={setSubmitData}
          />
        );

      case "Toggle":
        return (
          <Toggle
            item={item}
            addData={addData}
            setSubmitData={setSubmitData}
            submitData={submitData}
          />
        );
      case "Uploader":
        return (
          <AntUpload
            item={item}
            addData={addData}
            setSubmitData={setSubmitData}
            submitData={submitData}
            isEditing={isEditing}
            editValues={editValues}
          />
        );
      case "Button":
        return <AntButton item={item} />;

      case "Header":
        return <AntHeader item={item} />;
      case "Image":
        return <Image item={item} />;
      case "Label":
        return <Label item={item} />;
      case "Link":
        return <Link item={item} />;

      case "Progress_circle":
        return <ProgressCircle item={item} />;
      case "Progress_line":
        return <ProgressLine item={item} />;
      case "Signature":
        return (
          <UISignature
            item={item}
            addData={addData}
            setSubmitData={setSubmitData}
            submitData={submitData}
          />
        );
      case "Camera":
        return (
          <SnippetCamera
            item={item}
            addData={addData}
            setSubmitData={setSubmitData}
            submitData={submitData}
          />
        );
      default:
        return;
    }
  };

  return (
    <div>
      {formFields?.data?.formSchema?.fields.map((i) => (
        <div className={`mb-2`} style={i.css} key={i.key}>
          {getInputType(i)}
        </div>
      ))}

      {/* {isEditing && (
        <div className="mb-3 mt-4">
          <label className="form-label">{trans("Edit Notes")}</label>
          <textarea
            className="form-control"
            rows={4}
            value={addData.values.edit_notes || ""}
            onChange={(e) =>
              addData.setFieldValue("edit_notes", e.target.value)
            }
            placeholder={trans("Notes describing what was changed")}
          />
        </div>
      )} */}
    </div>
  );
}
